export class HttpError extends Error {
  constructor(
    message: string,
    public statusCode: number
  ) {
    super(message)
    this.name = this.constructor.name
    Object.setPrototypeOf(this, HttpError.prototype)
  }
}

export class BadRequestError extends HttpError {
  constructor(message?: string) {
    super(message || 'Bad request', 400)
  }
}

export class UnauthorizedError extends HttpError {
  constructor(message?: string) {
    super(message || 'Unauthorized', 401)
  }
}

export class NotFoundError extends HttpError {
  constructor(message?: string) {
    super(message || 'Not found', 404)
  }
}

export class ForbiddenError extends HttpError {
  constructor(message?: string) {
    super(message || 'Forbidden', 403)
  }
}

export class GatewayTimeoutError extends HttpError {
  constructor(message?: string) {
    super(message || 'Gateway timeout', 504)
  }
}

export class MethodNotAllowedError extends HttpError {
  constructor(message?: string) {
    super(message || 'Method not allowed', 405)
  }
}
